module.exports = __webpack_public_path__ + "static/www-ee10b82b73da7ae26f9c9dc90008edf0.png";